// null check
export function isEmpty(value) {
    if (value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length)) {
        return true
    } else {
        return false
    }
}

// device check
export function deviceInfo() {
    if (navigator.userAgent.match(/Android/i) != null) {
        return "Android";
    }
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i) != null) {
        return "iOS";
    }
    if (navigator.userAgent.match(/BlackBerry/i) != null) {
        return "BlackBerry";
    }
    return "";
}


// email check
export function isEmail(value) {
    const regex = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;
    if (regex.test(value)) {
        return true;
    } else {
        return false;
    }
}

// 14 세미만 체크
export function isUnder14(birthday) {
    const date = new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10)
        month = "0" + month;
    if (day < 10)
        day = "0" + day;

    const today = year + month + day;

    const n = parseInt(today) - parseInt(birthday) - 140000;
    return n < 0;
}

// null 을 0 으로 변환
export function nullToZero(value) {
    if (isEmpty(value)) {
        return 0;
    } else {
        return value;
    }
}

// null 을 empty string 으로 변환
export function nullToEmptyString(value) {
    if (isEmpty(value)) {
        return "";
    } else {
        return value;
    }
}

// 숫자만 입력
export function numericText(value) {
    const regex = /[^0-9]/g;
    return value.replace(regex, "");
}

// 월에 해당하는 1 부터 12까지 Return
export function monthList() {
    let result = [];

    for (let i = 1; i <= 12; i++) {
        if ((String(i).length) == 1)
            result.push("0" + String(i));
        else
            result.push(String(i));
    }

    return result;
}

// 해당년도 월에 해당하는 모든 일자 Return
export function dayList(year, month) {
    const lastDay = lastDayOfMonth(year, month);

    let dayList = [];
    for (let i = 1; i <= lastDay; i++) {
        if ((String(i).length) === 1)
            dayList.push("0" + String(i));
        else
            dayList.push(String(i));
    }

    return dayList;
}

// 월의 마지막 일짜
export function lastDayOfMonth(year, month) {
    return ( new Date(year, month, 0) ).getDate();
}

// 분을 표준 포멧을 변환 ex) 120 02:00
export function minuteToStringFormat(minute) {
    let date = new Date(null);
    date.setSeconds(minute);
    return date.toISOString().substr(14, 5);
}

// 현재 주차정보
export function getNumberOfWeek() {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
}

// 숫자 3자리마다 ',' 표시
export function thousandSeparator(amount) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// MySQL Date 형식을 yyyy-mm-dd 형태로 변경
export function convertDateYYYYMMDD (isoFormatDateString) {
    if (isEmpty(isoFormatDateString)) {
        return "";
    }

    const date = new Date(isoFormatDateString);
    return date.getUTCFullYear() + '-' + ('00' + (date.getUTCMonth()+1)).slice(-2) + '-' + ('00' + date.getUTCDate()).slice(-2) + ' ';
}

// MySQL Date 형식을 yyyy-mm-dd hh24:mi:ss 형태로 변경
export function convertDateYYYYMMDDHH24MISS (isoFormatDateString) {
    const date = new Date(isoFormatDateString);
    return date.getUTCFullYear() + '-' + ('00' + (date.getUTCMonth()+1)).slice(-2) + '-' + ('00' + date.getUTCDate()).slice(-2) + ' ' +
        ('00' + date.getUTCHours()).slice(-2) + ':' + ('00' + date.getUTCMinutes()).slice(-2) + ':' + ('00' + date.getUTCSeconds()).slice(-2);
}

// MySQL Date 형식을 yyyy-mm-dd hh24:mi 형태로 변경
export function convertDateYYYYMMDDHH24MI (isoFormatDateString) {
    const date = new Date(isoFormatDateString);
    return date.getUTCFullYear() + '-' + ('00' + (date.getUTCMonth()+1)).slice(-2) + '-' + ('00' + date.getUTCDate()).slice(-2) + ' ' +
        ('00' + date.getUTCHours()).slice(-2) + ':' + ('00' + date.getUTCMinutes()).slice(-2);
}

// yyyymmdd 형식을 yyyy-mm-dd 형태로 변경
export function displayYYYYMMDD(value) {
    if (isEmpty(value)) {
        return "";
    }

    return value.substring(0, 4) + "-" + value.substring(4, 6) + "-" + value.substring(6, 8);
}

// yyyymmddhh24miss 형식을 yyyy-mm-dd hh24:mi:ss 형태로 변경
export function displayYYYYMMDDHH24MISS(value) {
    if (isEmpty(value)) {
        return "";
    }

    return value.substring(0, 4) + "-" + value.substring(4, 6) + "-" + value.substring(6, 8) +
        " " + value.substring(8, 10) + ":" + value.substring(10, 12) + ":" + value.substring(12, 14);
}


// form 없이 post 요청
export function post(path, params, method='post') {
    const form = document.createElement('form');
    form.method = method;
    form.action = path;

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}


// 초등, 중등 표기 줄임
export function convertSchoolGrade(value) {
    if (value === "초등1 2 3 4 5 6 ")
        value = "초등";
    if (value === "중등1 2 3 ")
        value = "중등";
    if (value === "통합1 2 3 4 5 6 ")
        value = "통합";
    return value;
}
